import React from 'react';
import { LanguageContext } from './contexts/LanguageContext.js';

const Language = ({ children, language }) => {
    return React.createElement(LanguageContext, { value: language }, children);
};
Language.displayName = 'Language';

export { Language };
//# sourceMappingURL=Language.js.map
